// Only email-format HTML reaches the visual editors. Server validation remains authoritative.
const EmailHtml = (() => {
    const policy=EmailHtmlPolicy;
    const purifier=DOMPurify(window); // Private instance; hooks cannot change unrelated consumers.
    purifier.addHook('uponSanitizeAttribute',(node,data)=>{
        const tag=node.nodeName.toLowerCase(), name=data.attrName;
        if(!(policy.attributes['*'].includes(name) || (policy.attributes[tag]||[]).includes(name)))data.keepAttr=false;
        if(name==='style')data.attrValue=policy.cleanStyle(data.attrValue);
        if(name==='href' && !policy.safeUrl(data.attrValue))data.keepAttr=false;
        if(name==='src' && !policy.safeUrl(data.attrValue,true,false))data.keepAttr=false;
        if(/[{}]/.test(data.attrValue) && !(name==='href' && data.attrValue==='{{enlace}}'))data.keepAttr=false;
    });
    const clean = html => {
        if(typeof html!=='string' || html.length>policy.maxLength)throw new Error('El HTML supera el límite de 100.000 caracteres');
        return purifier.sanitize(html,{ALLOWED_TAGS:policy.tags,ALLOWED_ATTR:[...new Set(Object.values(policy.attributes).flat())],ALLOW_DATA_ATTR:false,ALLOW_ARIA_ATTR:false,FORBID_CONTENTS:['script','style','iframe','object','svg','math','textarea','noscript']});
    };
    const mounted=new WeakSet();
    function mount(editor,code){
        if(!editor || mounted.has(editor))return;
        mounted.add(editor);
        editor.addEventListener('click',event=>{if(event.target.closest?.('a'))event.preventDefault();});
        editor.addEventListener('paste',event=>{
            event.preventDefault();
            try {
                const clipboard=event.clipboardData;
                const html=clipboard?.getData('text/html');
                const safe=clean(html || Utils.sanitizeHTML(clipboard?.getData('text/plain')||'').replace(/\r?\n/g,'<br>'));
                editor.focus(); document.execCommand('insertHTML',false,safe);
                if(code)code.value=editor.innerHTML;
            }catch(error){Utils.showToast(error.message,'error');}
        });
        editor.addEventListener('drop',event=>{event.preventDefault();Utils.showToast('Pega el contenido o utiliza Insertar imagen para revisarlo de forma segura.','info');});
        editor.addEventListener('dragover',event=>event.preventDefault());
    }
    function set(editor,html,code){
        const safe=clean(html);
        editor.innerHTML=safe;
        if(code)code.value=safe;
        mount(editor,code);
        return safe;
    }
    function validLink(value,image=false){
        if(policy.safeUrl(value,image))return true;
        Utils.showToast(image ? 'Usa una imagen HTTPS o PNG/JPEG/GIF/WebP en base64.' : 'Usa un enlace HTTP/HTTPS, mailto, tel o la variable {{enlace}}.','warning');
        return false;
    }
    // Sandboxed frame with no scripts, links or remote content except HTTPS/data images.
    function frame(html,title='Correo aislado: enlaces y scripts deshabilitados'){
        const safe=clean(html);
        const node=document.createElement('iframe');
        node.setAttribute('sandbox','');node.referrerPolicy='no-referrer';node.title=title;
        node.srcdoc='<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="default-src \'none\'; script-src \'none\'; style-src \'unsafe-inline\'; img-src https: data:; base-uri \'none\'; form-action \'none\'"><meta name="referrer" content="no-referrer"></head><body>'+safe+'</body></html>';
        return node;
    }
    function preview(html){
        const frameNode=frame(html);
        const dialog=document.createElement('dialog');
        dialog.style.cssText='width:min(850px,94vw);max-width:94vw;max-height:94vh;margin:auto;border:1px solid #dce4e1;border-radius:12px;padding:16px;';
        const title=document.createElement('h2');title.textContent='Vista previa de la plantilla';title.style.marginTop='0';
        const close=document.createElement('button');close.type='button';close.className='btn btn-secondary';close.textContent='Cerrar vista previa';
        close.addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>dialog.remove());
        frameNode.style.cssText='display:block;width:100%;height:65vh;border:1px solid #dce4e1;margin:12px 0;background:white;';
        dialog.append(title,frameNode,close);document.body.appendChild(dialog);dialog.showModal();close.focus();
    }
    function previewEditor(editorId,codeId,mode){
        try {preview(mode==='html' ? document.getElementById(codeId).value : document.getElementById(editorId).innerHTML);}
        catch(error){Utils.showToast(error.message,'error');}
    }
    return {clean,set,mount,validLink,frame,preview,previewEditor};
})();
window.EmailHtml=EmailHtml;
